import {checkIsFirefox} from "./browserDetection"

const isFirefox = checkIsFirefox()

export const scrollTableToBottom = (tableRef, delay = 0) => {
    setTimeout(() => {
        if (tableRef?.current) {
            if (isFirefox) {
                tableRef.current.scrollTop = tableRef.current.scrollHeight
            } else {
                const container = tableRef.current._container
                if (container) {
                    container.scrollTop = container.scrollHeight
                }
            }
        }
    }, delay)
}
